import dayjs from 'dayjs';

export const getAdobeDelayRenderTime = (pathname) => {
  const now = dayjs();
  return now.isBefore(dayjs('2025-06-01')) && pathname.startsWith('/search') ? '0' : '5000';
};

export const formatLocaleForClickToChatConfig = (locale) => (locale && locale.includes('-') ? locale.split('-')[1] : 'US');
